import { useEffect, useRef, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useBranding } from "@/context/BrandingContext";
import { LogoMark } from "@/components/logo/AetriaLogo";
import { BrandMark } from "@/components/logo/BrandLogo";

const PLATFORM_PATHS = ["/platform", "/landing", "/signup"];
const MIN_MS = 1700; // fuller logo moment (client-tuned)
const MAX_MS = 3400; // hard cap — never block on a slow API

export default function SplashScreen() {
  const { user } = useAuth();
  const { branding, noTenant, resolved } = useBranding();
  const [gone, setGone] = useState(false);
  const [fading, setFading] = useState(false);
  const started = useRef(Date.now());

  const platformSurface = PLATFORM_PATHS.some((p) =>
    window.location.pathname.startsWith(p));
  // bootstrap resolved (or surface that never resolves tenant branding)
  const ready = user !== null && (resolved || noTenant || platformSurface);

  useEffect(() => {
    if (gone || fading) return undefined;
    const elapsed = Date.now() - started.current;
    const wait = ready ? Math.max(0, MIN_MS - elapsed) : Math.max(0, MAX_MS - elapsed);
    const t = setTimeout(() => setFading(true), wait);
    return () => clearTimeout(t);
  }, [ready, gone, fading]);

  useEffect(() => {
    if (!fading) return undefined;
    const t = setTimeout(() => setGone(true), 460);
    return () => clearTimeout(t);
  }, [fading]);

  if (gone) return null;

  const tenantBrand = !platformSurface && branding && branding.product_name !== "Aetria OS";
  const name = tenantBrand ? branding.product_name : "Aetria OS";
  const parts = name.split(" ");
  const head = parts.length > 1 ? parts.slice(0, -1).join(" ") : name;
  const tail = parts.length > 1 ? parts[parts.length - 1] : "";

  return (
    <div className={`splash-overlay ${fading ? "splash-fading" : ""}`}
      data-testid="splash-screen" aria-hidden="true">
      <div className="splash-inner">
        <div className="splash-mark">
          {tenantBrand ? <BrandMark size={72} inverted /> : <LogoMark size={72} inverted />}
        </div>
        <div className="splash-word text-white font-bold tracking-tight text-[22px]"
          data-testid="splash-wordmark">
          {head.toUpperCase()}
          {tail && (
            <span className="ml-1.5" style={{ color: "var(--brand-accent-bright)" }}>
              {tail.toUpperCase()}
            </span>
          )}
        </div>
        <div className="splash-track"><div className="splash-bar" /></div>
      </div>
    </div>
  );
}
